import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheetGuide from "../pages/article/basetao-spreadsheet-guide/page";
import BasetaoReview from "../pages/article/basetao-review/page";
import BasetaoShippingCost from "../pages/article/basetao-shipping-cost/page";
import BasetaoCouponGuide from "../pages/article/basetao-coupon-guide/page";
import BasetaoWarehouseGuide from "../pages/article/basetao-warehouse-guide/page";
import BasetaoBuyingGuide from "../pages/article/basetao-buying-guide/page";
import BasetaoAlternatives from "../pages/article/basetao-alternatives/page";
import BasetaoSafetyGuide from "../pages/article/basetao-safety-guide/page";
import BasetaoProsCons from "../pages/article/basetao-pros-cons/page";
import BasetaoDeliveryTime from "../pages/article/basetao-delivery-time/page";
import BasetaoProductResearch from "../pages/article/basetao-product-research/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <BasetaoSpreadsheetGuide />,
  },
  {
    path: "/basetao-review",
    element: <BasetaoReview />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <BasetaoShippingCost />,
  },
  {
    path: "/basetao-coupon-guide",
    element: <BasetaoCouponGuide />,
  },
  {
    path: "/basetao-warehouse-guide",
    element: <BasetaoWarehouseGuide />,
  },
  {
    path: "/basetao-buying-guide",
    element: <BasetaoBuyingGuide />,
  },
  {
    path: "/basetao-alternatives",
    element: <BasetaoAlternatives />,
  },
  {
    path: "/basetao-safety-guide",
    element: <BasetaoSafetyGuide />,
  },
  {
    path: "/basetao-pros-cons",
    element: <BasetaoProsCons />,
  },
  {
    path: "/basetao-delivery-time",
    element: <BasetaoDeliveryTime />,
  },
  {
    path: "/basetao-product-research",
    element: <BasetaoProductResearch />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;